import React, { useEffect, useRef } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { heartbeatApiHandler } from "../services/AdminIndex";

const HEARTBEAT_INTERVAL_MS = 30000;

const PrivateComponent = () => {
  // const adminLogin = useSelector((state) => {
  //   return state.ERPAdminReducer.isAdminLogin;
  // });
  // const location = useLocation();

  const { isAdminLogin, adminDetail, token } = useSelector((state) => {
    return state.ERPAdminReducer;
  });
  const domainRef = useRef(adminDetail?.domain || null);

  // Keeps the backend's single-active-session lock accurate: as long as any
  // tab of this login is open, its heartbeat keeps loginMaster.LastHeartbeat
  // fresh. Once every tab is closed (or the network drops), heartbeats stop
  // and the session goes stale after SESSION_STALE_SECONDS (AuthController.js),
  // freeing the account for a new login. There's deliberately no
  // beforeunload/pagehide-triggered logout here — those events also fire on
  // a plain page refresh and on closing just one of several open tabs, which
  // would wrongly kill a still-active session.
  useEffect(() => {
    if (!isAdminLogin || !token) return;

    heartbeatApiHandler(token);
    const intervalId = setInterval(
      () => heartbeatApiHandler(token),
      HEARTBEAT_INTERVAL_MS
    );

    return () => clearInterval(intervalId);
  }, [isAdminLogin, token]);

  return isAdminLogin ? (
    <Outlet />
  ) : (
    <Navigate to={`/${domainRef.current || ""}`} />
  );
};

export default PrivateComponent;
